import { QueryClient } from '@tanstack/vue-query'

export const adminQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
    mutations: { retry: false },
  },
})
